module.exports = __webpack_public_path__ + "img/小组件.1fe93700.png";